import { useSelector } from 'react-redux';

import { getUser } from '../../../selectors/user';

export function useGetInfoCardProps() {
  const { isAgent } = useSelector(getUser);

  if (isAgent) {
    return {
      role: 'realtor',
      title: 'Риелтору',
      text: 'Отправьте отчёт от своего имени. Уточните параметры объекта и список аналогов. Укажите цену в диапазоне оценки и получите значок «Хорошая цена».',
    };
  }

  return {
    role: 'searcher',
    title: 'Покупателю или арендатору',
    text: 'Узнайте рыночную стоимость: можно поторговаться и не переплачивать',
  };
}
